import * as React from 'react';

var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgSmGoogle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M28 17.253c0-.804-.073-1.573-.21-2.313H17.234v4.238l6.08.002c-.247 1.41-1.04 2.612-2.256 3.414v2.75h3.618C26.79 23.428 28 20.598 28 17.254Z",
  fill: "#4285F4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.058 22.591c-1.007.666-2.304 1.055-3.822 1.055-2.931 0-5.418-1.934-6.309-4.542H7.195v2.836C9.044 25.534 12.845 28 17.236 28c3.035 0 5.585-.977 7.441-2.66l-3.619-2.749Z",
  fill: "#34A853"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.576 17.003c0-.732.125-1.44.352-2.105v-2.836H7.195A10.762 10.762 0 0 0 6 17.002c0 1.779.432 3.456 1.195 4.942l3.733-2.836a6.51 6.51 0 0 1-.352-2.105Z",
  fill: "#FABB05"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.236 10.354c1.657 0 3.14.559 4.311 1.65l3.207-3.137C22.807 7.09 20.267 6 17.236 6c-4.39 0-8.192 2.466-10.041 6.06l3.732 2.836c.891-2.607 3.378-4.542 6.31-4.542Z",
  fill: "#E94235"
})));

export { SvgSmGoogle as default };
